import React, { useState } from "react";
import { FiMessageSquare, FiX, FiSend } from "react-icons/fi";
import { motion, AnimatePresence } from "framer-motion";

export const Messager = () => {
    const users = [
        { id: 1, name: "Aravindan", unread: 2 },
        { id: 2, name: "Kumar", unread: 1 },
        { id: 3, name: "Guna", unread: 0 },
        { id: 4, name: "Sujith", unread: 3 },
    ];

    const [activeUser, setActiveUser] = useState(null);
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [typing, setTyping] = useState(false);

    const [messages, setMessages] = useState({
        1: [{ text: "Hi Sir", from: "user" }],
        2: [{ text: "Homework doubt", from: "user" }],
        3: [{ text: "Project help venum", from: "user" }],
        4: [{ text: "Exam syllabus send pannunga", from: "user" }],
    });

    const sendMessage = () => {
        if (!message.trim()) return;

        setMessages((prev) => ({
            ...prev,
            [activeUser.id]: [
                ...(prev[activeUser.id] || []),
                { text: message, from: "me" },
            ],
        }));

        setMessage("");
        setTyping(true);

        setTimeout(() => {
            setTyping(false);
            setMessages((prev) => ({
                ...prev,
                [activeUser.id]: [
                    ...(prev[activeUser.id] || []),
                    { text: "Ok sir 👍", from: "user" },
                ],
            }));
        }, 1500);
    };

    return (
        <>
            {/* FLOATING BUTTON */}
            {!open && (
                <button
                    onClick={() => setOpen(true)}
                    className="
            fixed bottom-5 right-5 z-50
            bg-green-600 text-white p-4 rounded-full
            shadow-xl hover:scale-110 transition
          "
                >
                    <FiMessageSquare size={22} />
                </button>
            )}

            {/* CHAT WINDOW */}
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ opacity: 0, y: 100 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 100 }}
                        className="
              fixed bottom-0 right-0 md:bottom-6 md:right-6
              w-full md:w-[380px]
              h-full md:h-[540px]
              bg-[#ece5dd]
              rounded-none md:rounded-3xl
              shadow-2xl z-50
              flex overflow-hidden
            "
                    >
                        {/* USERS */}
                        <div className="w-1/3 bg-white p-2 border-r hidden md:block">
                            {users.map((u) => (
                                <div
                                    key={u.id}
                                    onClick={() => setActiveUser(u)}
                                    className="
                    p-2 mb-2 rounded-lg cursor-pointer
                    hover:bg-gray-100 flex justify-between items-center
                  "
                                >
                                    <span className="text-sm">{u.name}</span>
                                    {u.unread > 0 && (
                                        <span className="bg-green-500 text-white text-xs px-2 rounded-full">
                                            {u.unread}
                                        </span>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* CHAT */}
                        <div className="flex-1 flex flex-col">
                            {/* HEADER */}
                            <div className="bg-green-600 text-white px-4 py-3 flex justify-between">
                                <span className="font-semibold">
                                    {activeUser?.name || "Select Chat"}
                                </span>
                                <button onClick={() => setOpen(false)}>
                                    <FiX />
                                </button>
                            </div>

                            {/* MESSAGES */}
                            <div className="flex-1 p-3 overflow-y-auto space-y-2">
                                {messages[activeUser?.id]?.map((m, i) => (
                                    <motion.div
                                        key={i}
                                        initial={{ opacity: 0, scale: 0.9 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        className={`
                      max-w-[75%] px-3 py-2 rounded-xl text-sm
                      ${m.from === "me"
                                                ? "bg-green-500 text-white ml-auto"
                                                : "bg-white"
                                            }
                    `}
                                    >
                                        {m.text}
                                    </motion.div>
                                ))}

                                {typing && (
                                    <div className="text-xs text-gray-500">typing...</div>
                                )}
                            </div>

                            {/* INPUT */}
                            {activeUser && (
                                <div className="p-2 bg-white flex gap-2">
                                    <input
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyDown={(e) => e.key === "Enter" && sendMessage()}
                                        placeholder="Type message"
                                        className="flex-1 border rounded-full px-4 py-2 text-sm"
                                    />
                                    <button
                                        onClick={sendMessage}
                                        className="bg-green-600 text-white px-4 rounded-full"
                                    >
                                        <FiSend />
                                    </button>
                                </div>
                            )}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    );
};
